import React from 'react';

export const ContextLayout = React.createContext();
